import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import { pushNewHistoryOfPreview } from "@/common/preview/push-new-history-of-preview";

const getShowPageScope = () => ShowPageScopeCollector.get([
  'previews',
  'layoutChanges',
  'canvas_data'
]);

export const removeAllElementParamsAndChanges = (instanceId, elementId) => {
  const { previews, layoutChanges, canvas_data } = getShowPageScope();

  for (let i = layoutChanges.length - 1; i >= 0; i--) {
    if (
      !(layoutChanges[i].instance_id === instanceId && layoutChanges[i].key.includes(elementId))
    ) {
      continue;
    }

    layoutChanges.splice(i, 1);
  }

  const canvasParams = previews.find((preview) => preview.id === instanceId);

  if (canvasParams) {
    Object.keys(canvasParams.data).forEach((key) => {
      if (key.includes(elementId)) {
        delete canvasParams.data[key];
      }
    });
  }

  const currentCanvasData = canvas_data?.[instanceId];

  if (currentCanvasData?.additionalSmartObjects) {
    currentCanvasData.additionalSmartObjects = currentCanvasData.additionalSmartObjects
      .filter(field => field !== elementId);
  }

  pushNewHistoryOfPreview(instanceId);

  if (layoutChanges.length === 0) {
    $('.btn-save-changes').prop("disabled", true);
    $('.btn-cancel-changes').addClass('d-none');
  }
}
